export const BREAKPOINTS = {
	0: {
		slidesPerView: 1.2,
		spaceBetween: 24
	},
	400: {
		slidesPerView: 1.4,
		spaceBetween: 24
	},
	550: {
		slidesPerView: 1.6,
		spaceBetween: 32
	},
	600: {
		slidesPerView: 1.7,
		spaceBetween: 32
	},
	670: {
		slidesPerView: 1.8,
		spaceBetween: 32
	},
	750: {
		slidesPerView: 2.2,
		spaceBetween: 32
	},
	850: {
		slidesPerView: 2.4,
		spaceBetween: 32
	},
	900: {
		slidesPerView: 2,
		spaceBetween: 32
	},
	1200: {
		slidesPerView: 3,
		spaceBetween: 32
	}
};
